import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Colors } from "../../constants/colors";


const StyledContainer = styled("div")(({ theme }) => ({
  display: "inline-block",
  position: "relative",
  padding: theme.spacing(3),
  width: "100%",
  height: "100%",
  border: `dotted ${Colors.GRAY300} 2px`,
  borderRadius: "3px",
  backgroundColor: theme.palette.background.default,
  "& :hover": {
    border: "none",
  },
  "& .hidden-container": {
    border: "dashed grey 2px",
    borderRadius: "3px",
    backgroundColor: "rgba(255,255,255,.8)",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  "& .drop-zone-container": {
    position: "absolute",
    top: "30%",
    bottom: "30%",
    right: 0,
    left: 0,
    textAlign: "center",
    color: Colors.GRAY300,
    fontSize: 36,
  },
}));
const SFDragDrop = (props) => {
  const [drag, setDrag] = useState(false);
  const [dragCounter, setDragCounter] = useState(0);
  const { t } = useTranslation();

  const dropRef = React.createRef();
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.effectAllowed = "move";
  };
  const handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter((prev) => {
      return { dragCounter: prev.dragCounter + 1 };
    });
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setDrag(true);
    }
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter(0);
    if (dragCounter === 0) {
      setDrag(false);
    }
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDrag(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      props.handleDrop(e);
      e.dataTransfer.clearData();
      setDragCounter(0);
    }
  };

  return (
    <StyledContainer
      ref={dropRef}
      onDrop={(e) => handleDrop(e)}
      onDragOver={(e) => handleDrag(e)}
      onDragEnter={(e) => handleDragIn(e)}
      onDragLeave={(e) => handleDragOut(e)}
    >
      {drag && (
        <div className="hidden-container">
          <div className="drop-zone-container">
            <div>{t("components.fileuploader.dropout")}</div>
          </div>
        </div>
      )}
      {props.children}
    </StyledContainer>
  );
};

SFDragDrop.propTypes = {
  handleDrop: PropTypes.func,
  children: PropTypes.node,
};

export default SFDragDrop;
